import keyMirror from 'key-mirror';

function async(name) {
    return {
        [name]: null,
        [`${name}_SUCCESS`]: null,
        [`${name}_ERROR`]: null
    };
}

function single(name) {
    return {[name]: null}
}

export const actionTypes = keyMirror({
    ...async('DEPARTMENTS_CLEAR_DETAIL'),
    ...async('DEPARTMENTS_FETCH_ALL'),
    ...async('DEPARTMENTS_FETCH_ONE'),
    ...async('DEPARTMENTS_UPDATE_ONE'),
    ...async('DEPARTMENTS_CREATE_ONE'),
    ...async('ACCIDENTS_CLEAR_DETAIL'),
    ...async('ACCIDENTS_FETCH_ALL'),
    ...async('ACCIDENTS_FETCH_ONE'),
    ...async('ACCIDENTS_UPDATE_ONE'),
    ...async('ACCIDENTS_CREATE_ONE'),
    ...async('REPORTS_CLEAR_DETAIL'),
    ...async('REPORTS_FETCH_ALL'),
    ...async('REPORTS_FETCH_ONE'),
    ...async('REPORTS_UPDATE_ONE'),
    ...async('REPORTS_CREATE_ONE'),
    ...async('REPORTS_SUBMIT_ONE_VCA'),
    ...async('USERS_CLEAR_DETAIL'),
    ...async('USERS_FETCH_ALL'),
    ...async('USERS_FETCH_ONE'),
    ...async('USERS_UPDATE_ONE'),
    ...async('USERS_CREATE_ONE'),
    ...single('SPINNING_START'),
    ...single('SPINNING_STOP'),
    ...single('SWITCH_USER'),
    ...single('UPDATE_PROFILE'),
    ...single('DELETE_PROFILE'),
    ...async('USER_FETCH'),
    ...single('SNACKBAR'),
    ...single('SNACKBAR_CLEAR'),
});